import { type FC, type ReactNode } from "react";

import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors } from "@snapchat/snap-design-system";

import { ContentHeader } from "../../../shared/components";

import { ChartPaper } from "./LensInsightsPage.styles";

const Section = styled.section`
    display: flex;
    flex-direction: column;

    font-size: 12px;
    line-height: 16px;
    color: ${Colors.Black.V50};
`;

const ChartCardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
`;

const sectionPaper = css`
    flex-grow: 1;
    min-height: 240px;
    margin-top: 16px;
`;

const sectionHeader = css`
    flex-grow: 1;
`;

interface ChartCardProps {
    title: ReactNode;
    subtitle?: ReactNode;
    className?: string;
    children?: ReactNode;
}
export const ChartCard: FC<ChartCardProps> = ({ children, className = "", ...headerProps }) => (
    <Section className={className}>
        <ContentHeader className={sectionHeader} {...headerProps} />
        <ChartPaper className={sectionPaper}>
            <ChartCardWrapper>{children}</ChartCardWrapper>
        </ChartPaper>
    </Section>
);
